import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { menuLayoutRoute } from 'root/MenuLayout';

const searchSchema = z.object({
  assignNewRolesModalOpen: z.boolean().optional(),
});

export const accessManagementMainRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  path: '/access-management',
  component: lazyRouteComponent(() => import('./AccessManagementView')),
  validateSearch: searchSchema.parse,
});
